import { useEffect, useRef } from 'react';
import styles from './_tooltip.module.scss';

let tooltipPortalEl: HTMLElement | null = null;

export const getTooltipPortalEl = () => tooltipPortalEl;
export const setTooltipPortalEl = (el: HTMLDivElement) => {
  tooltipPortalEl = el;
};

export const TooltipPortal = () => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setTooltipPortalEl(ref.current);
    }
  }, []);
  return <div ref={ref} className={styles.TooltipPortal} />;
};
